import { PageLink, PageTitle } from '../layout/core';
import { WebhooksList } from '../views/developers/WebhooksList';
import { WebhooksPage } from '../components/developers/webhooks_page/WebhooksPage';
import React from 'react';
import { WebhookCreateComponent } from '../components/developers/webhooks_page/WebhookCreateComponent';
import { Logs } from '../views/developers/Logs';
import { SITE_ROUTES } from '../constants/developer/site-constants/site-constants';
import { SiteDetails } from '../views/developers/SiteDetails';
import { UiWidget } from '../components/developers/sites/UiWidget';
import { SenseJS } from '../components/developers/sites/SenseJS';
import { MerchantSitesPage } from '../views/merchants/details/MerchantSitesPage';
import { Sftp } from '../views/developers/Sftp';
import { ClientLogs } from '../views/developers/ClientLogs';
import { TFunction } from 'react-i18next';
import { ApiKeysPage } from '../views/developers/ApiKeysPage';

const BASE_URL = '/developers';

export enum DEVELOPERS_ROUTES {
  API_KEYS = 'api-keys',
  WEBHOOKS = 'webhooks',
  ACTIVITY_LOGS = 'activity-logs',
  SITES = 'sites',
  SFTP = 'sftp',
  LOGS = 'logs',
}

export const developersBreadCrumbs: Array<PageLink> = [
  {
    title: 'MENU.DEVELOPERS',
    path: `${BASE_URL}/${DEVELOPERS_ROUTES.WEBHOOKS}`,
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
];

interface Props {
  key: string,
  pathname: string,
  component: JSX.Element
}

export const developersRoutes = (t: TFunction): Props[] => [
  {
    key: DEVELOPERS_ROUTES.API_KEYS,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.API_KEYS}`,
    component: (
        <>
          <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.API_KEYS')}</PageTitle>
          <ApiKeysPage />
        </>
    ),
  },
  {
    key: DEVELOPERS_ROUTES.WEBHOOKS,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.WEBHOOKS}`,
    component: (
      <WebhooksPage>
        <>
          <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.WEBHOOKS')}</PageTitle>
          <WebhooksList />
        </>
      </WebhooksPage>
    ),
  },
  {
    key: `${DEVELOPERS_ROUTES.WEBHOOKS}_id`,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.WEBHOOKS}/:webhookId`,
    component: (
      <WebhooksPage>
        <>
          <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.WEBHOOKS')}</PageTitle>
          <WebhookCreateComponent />
        </>
      </WebhooksPage>
    ),
  },
  {
    key: DEVELOPERS_ROUTES.ACTIVITY_LOGS,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.ACTIVITY_LOGS}`,
    component: (
      <WebhooksPage>
        <>
          <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.WEBHOOKS')}</PageTitle>
          <Logs />
        </>
      </WebhooksPage>
    ),
  },
  {
    key: DEVELOPERS_ROUTES.SITES,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.SITES}`,
    component: (
      <>
        <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.SITES')}</PageTitle>
        <MerchantSitesPage/>
      </>
    ),
  },
  {
    key: `${DEVELOPERS_ROUTES.SITES}-id`,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.SITES}/:id/${SITE_ROUTES.SITE_INFO}`,
    component: <SiteDetails isInfo={true} />,
  },
  {
    key: `${DEVELOPERS_ROUTES.SITES}-${SITE_ROUTES.WIDGET}`,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.SITES}/:id/${SITE_ROUTES.WIDGET}`,
    component: (
      <SiteDetails>
        <UiWidget />
      </SiteDetails>
    ),
  },
  {
    key: `${DEVELOPERS_ROUTES.SITES}-${SITE_ROUTES.SENSE_JS}`,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.SITES}/:id/${SITE_ROUTES.SENSE_JS}`,
    component: (
      <SiteDetails>
        <SenseJS />
      </SiteDetails>
    ),
  },
  {
    key: DEVELOPERS_ROUTES.SFTP,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.SFTP}`,
    component: (
      <>
        <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.SFTP')}</PageTitle>
        <Sftp/>
      </>
    ),
  },
  {
    key: DEVELOPERS_ROUTES.LOGS,
    pathname: `${BASE_URL}/${DEVELOPERS_ROUTES.LOGS}`,
    component: (
      <>
        <PageTitle breadcrumbs={developersBreadCrumbs}>{t('MENU.LOGS')}</PageTitle>
        <ClientLogs/>
      </>
    ),
  },
];
